import { type DirectusFiles } from '@funnellab/shared/src/types/directus.ts';
import { directusClient } from '@src/api/DirectusClient.ts';
import { type PaginationData } from '../api.types';

export class UploadService {
  async uploadFile(file: File, folder?: string): Promise<DirectusFiles> {
    return await directusClient.uploadFile(file, folder);
  }

  async deleteFile(id: string): Promise<void> {
    await directusClient.deleteFile(id);
  }

  downloadFile(id: string, filename?: string): void {
    const url = directusClient.getFileDownloadUrl(id);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename ?? '';
    a.target = '_blank';
    a.click();
  }

  getFileDownloadUrl(id: string): string {
    return directusClient.getFileDownloadUrl(id);
  }

  listFilesInFolder(
    folderId: string,
    paginationData?: PaginationData,
  ): Promise<DirectusFiles[]> {
    return directusClient.listFilesInFolder(folderId, paginationData);
  }

  moveToFolder(fileId: string, folderId: string): Promise<DirectusFiles> {
    return directusClient.moveFileToFolder(fileId, folderId);
  }
}

const fileService = new UploadService();
export default fileService;
